import React from "react";

export const WithHighlight = (Component, processProps) => React.forwardRef(({ "data-highlight": dataHighLight, color, ...props }, ref) => {
    const colorMap = {
        important: "primary.500",
        muted: "muted.400",
        error: "danger.900",
        info: "info.700",
        warning: "yellow.700",
        success: "success.700",
    }

    const weightMap = {
        important: "500",
        warning: "500",
        error: "500",
        info: "500",
        success: "500",
    }

    const lineProps = {
        invalid: "line-through"
    }


    let componentProps = {
        _text: {
            color: colorMap[dataHighLight] ?? color,
            fontWeight: weightMap[dataHighLight],
            textDecorationLine: lineProps[dataHighLight]
        }
    }

    

    componentProps = processProps?.(componentProps) || componentProps

    return <Component { ...props } ref={ref} { ...componentProps } />
})